import { render, staticRenderFns } from "./PortabilityPriceChange.vue?vue&type=template&id=4d705501&scoped=true"
import script from "./PortabilityPriceChange.vue?vue&type=script&lang=ts"
export * from "./PortabilityPriceChange.vue?vue&type=script&lang=ts"
import style0 from "./PortabilityPriceChange.vue?vue&type=style&index=0&id=4d705501&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d705501",
  null
  
)

export default component.exports